import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {auth, logInWithEmailAndPassword, signInWithEmailAndPassword, signInWithGoogle} from "../../tools/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Login.css";
import {Button, Image, Layout, message} from "antd";
import { Typography } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone, KeyOutlined, MailOutlined, LoadingOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { Space, Spin } from 'antd';
import {track} from "@amplitude/analytics-browser";
import logo from "../Resources/logo.png";
import axios from "axios";

const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 24,
        }}
        spin
    />
);

const { Title, Text } = Typography;
const { Header } = Layout;

function ClosedBeta() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();

    useEffect(() => {
        track("signin_shown");

        const key = "futurepedia_upvote_sent";

        if (localStorage.getItem(key) === null) {
            track("futurepedia_upvote_sent");
            axios.get("https://www.futurepedia.io/api/tool/b3ab5aac-702d-4b66-853c-a490ae968382?favourite=inc")

            localStorage[key] = true;
        }
    }, [])

    useEffect(() => {
        if (loading) {
            // maybe trigger a loading screen
            return;
        }
        if (user) navigate("/dashboard");
    }, [user, loading]);

    if (loading) {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                }}
            >
                <Spin indicator={antIcon} />
            </div>
        )
    }

    return (
        <div style={{fontFamily: "Avenir"}}>
            <Header className="header">
                <div className="flex flex-row items-center self-center h-16 gap-4">
                    <Image src={logo} preview={false} style={{width: "2rem", height: "2rem"}}/>
                    <Title
                        level={3}
                        style={{color: "white", marginBottom: 0}}
                        onClick={() => { navigate("/") }}
                    >
                        Dimensions
                    </Title>
                </div>
            </Header>

            <div className="login">
                <div className="login__container">
                    <Image preview={false} src={logo} style={{width: 96, height: 96, marginLeft: "auto", marginRight: "auto"}}/>
                    <Title>Dimensions</Title>
                    <Text style={{marginBottom: 16, fontSize: 18}}>
                        We're in a closed beta now. Fill out your email below to get access as soon as we'll go public.
                    </Text>
                    <Input
                        placeholder="E-mail Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        prefix={<MailOutlined />}
                        style={{marginBottom: 16}}
                    />
                    <Button
                        onClick={() => {
                            track('closed_beta_signup', {'email' : email});
                            message.success("Email sent. Check your inbox in a while.");
                        }}
                        type="primary"
                        style={{marginBottom: 16}}
                    >
                        Send
                    </Button>
                    <Button
                        onClick={() => navigate("../signin")}
                        type="link"
                        style={{marginTop: 8}}
                    >
                        I have an access
                    </Button>

                </div>
            </div>
        </div>
    );
}

export default ClosedBeta;
